import React from 'react';

import { Box, Grow, IconButton, Skeleton, Typography } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { RiCloseLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

import { useOperatorSession } from '@contexts/OperatorSeesionProvider';

type OperatorSessionExtendedPanelProps = {
    isOpen: boolean;
    children: React.ReactNode;
    closePanel?: () => void;
};

const OperatorSessionExtendedPanel = ({
    isOpen,
    children,
    closePanel,
}: OperatorSessionExtendedPanelProps) => {
    const { protocol } = useOperatorSession();
    const { theme } = useTheme();

    return (
        <>
            {isOpen && (
                <Grow
                    in
                    style={{ transformOrigin: 'bottom' }}
                    easing={
                        theme.transitions?.ease?.easeIn ||
                        'cubic - bezier(0.0, 0, 0.2, 1)'
                    }>
                    <Box
                        display="flex"
                        data-testid="operator-session-extended-panel"
                        sx={{
                            zIndex: 9,
                            boxShadow: 3,
                            borderRadius: 1,
                            width: theme.spacing(56.25),
                            height: theme.spacing(66.375),
                            position: 'fixed',
                            bottom: theme.spacing(11.5),
                            backgroundColor: 'background.paper',
                            border: '0',
                            ml: 'auto',
                            right: theme.spacing(3.25),
                            display: 'flex',
                            flexDirection: 'column',
                            px: 2,
                            py: 3,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                mb: 2,
                            }}>
                            <Box>
                                <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    component="h2">
                                    {protocol ? (
                                        <FormattedMessage
                                            id="OperatorSessionNotes.protocol"
                                            defaultMessage="No: {protocol}"
                                            values={{ protocol }}
                                        />
                                    ) : (
                                        <Skeleton
                                            data-testid="protocol-loader"
                                            width={theme.spacing(20)}
                                        />
                                    )}
                                </Typography>
                            </Box>
                            <Box>
                                {closePanel && (
                                    <IconButton
                                        data-testid="close-button"
                                        aria-label="close"
                                        onClick={closePanel}
                                        sx={{
                                            position: 'absolute',
                                            right: theme.spacing(2),
                                            top: theme.spacing(2),
                                            color: 'text.secondary',

                                            backgroundColor: 'transparent',
                                            '&:hover': {
                                                color: 'primary.dark',
                                                backgroundColor: 'transparent',
                                            },
                                        }}>
                                        <RiCloseLine
                                            size={theme.spacing(2.5)}
                                        />
                                    </IconButton>
                                )}
                            </Box>
                        </Box>

                        <Box>{children}</Box>
                    </Box>
                </Grow>
            )}
        </>
    );
};
export default OperatorSessionExtendedPanel;
